module.exports = __webpack_public_path__ + "media/paliwa/lpg@3x-7c6db5a1.svg";